export const PRODUCTION_SUBDOMAINS = [
  'bo',
  'v3',
];

export const PUBLIC_SUBDOMAINS = [
  'v3',
];
